import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';

export const DATE_PICKER_FIELD_VALUE_FORMAT = 'yyyy-MM-dd';
export const DATE_PICKER_FIELD_DISPLAY_FORMAT = 'MM/dd/yyyy';

export const parseDateValue = (value: string): Date | null => {
  if (!value) return null;
  const parsed = parse(value, DATE_PICKER_FIELD_VALUE_FORMAT, new Date());
  return isValid(parsed) ? parsed : null;
};

export const formatDateValue = (date: Date | null): string => {
  if (!date || !isValid(date)) return '';
  return format(date, DATE_PICKER_FIELD_VALUE_FORMAT);
};

export const toDisabledDateKey = (entry: Date | string): string => {
  if (typeof entry === 'string') return entry;
  return isValid(entry) ? format(entry, DATE_PICKER_FIELD_VALUE_FORMAT) : '';
};
